<template>
    <div class="ado-assignment">
        <div class="ado-assignment__header">
            <h5 class="ado-assignment__header-title">Assignments</h5>
        </div>
        <div class="container-fluid pt-4 pb-4">
            <div class="row">
                <div class="col-lg-4">
                    <div class="ado-assignment__card card">
                        <div class="card-body">
                            <div class="ado-assignment__profile">
                                <img :src="getAvatar" class="ado-assignment__avatar">
                                <div class="ado-assignment__description">
                                    <div class="ado-assignment__user">
                                        {{ getName }}
                                    </div>
                                    <div class="ado-assignment__department">
                                        {{ getDepartment }}
                                    </div>
                                </div>
                            </div>
                            <div class="ado-assignment__stats">
                                <div class="row">
                                    <div class="ado-assignment__stats--item col-6">
                                        <i class="far fa-user-clock fa-2x icon__warning"></i>
                                        <div class="ado-assignment__item">
                                            <div class="ado-assignment__item-title">
                                                Assigned
                                            </div>
                                            <div :class="[getQueueCountClass, 'ado-assignment__item-count']">
                                                {{ queueData.length }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="ado-assignment__stats--item col-6">
                                        <i class="far fa-user-check fa-2x icon__success"></i>
                                        <div class="ado-assignment__item">
                                            <div class="ado-assignment__item-title">
                                                Completed
                                            </div>
                                            <div :class="[getDequeueCountClass, 'ado-assignment__item-count']">
                                                {{ dequeueData.length }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-8">
                    <div class="card">
                        <div class="ado-assignment__title">
                            {{ getTitle }}
                            <button type="button" class="btn btn-sm btn-light-success float-right"
                                @click="getCompletedAssignments()"><i class="far fa-clipboard-check"></i>
                                Completed</button>
                            <button type="button" class="btn btn-sm btn-light-warning float-right mr-2"
                                @click="getAssignments()"><i class="far fa-clock"></i> Assigned</button>
                            <div v-if="hasCounsellorsAccess" class="form-group mt-3 mb-0">
                                <select class="form-control form-control-sm" id="counsellor" name="counsellor"
                                    v-model="counsellor" @change="getCounsellorData()">
                                    <option value="">No counsellor</option>
                                    <option v-for="counsellor in counsellors" :key="counsellor.username"
                                        :value="counsellor.username">{{ counsellor.commonName }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="card-body">
                            <transition name="fade">
                                <div v-if="alert.status" :class="getAlertClass" role="alert">
                                    <i :class="getAlertIcon"></i>{{ alert.message }}
                                </div>
                            </transition>
                            <div v-if="!dataLoad">
                                <div v-if="dataType == 'queue'" class="ado-assignment__queue-items">
                                    <div v-if="queueData.length > 0">
                                        <assignment-item v-for="item in queueData" :key="item.username" :item="item"
                                            :counsellors="counsellors" :type="getQueueType"
                                            @refreshAssignments="refreshAssignments" @setAlert="setAlert">
                                        </assignment-item>
                                    </div>
                                    <div v-else class="alert alert-primary">
                                        <i class="far fa-bells"></i> There are currently no queue items assigned to you.
                                    </div>
                                </div>
                                <div v-else class="ado-assignment__dequeue-items">
                                    <div v-if="dequeueData.length > 0">
                                        <assignment-item v-for="item in dequeueData" :key="item.username" :item="item"
                                            :counsellors="counsellors" :type="getDequeueType"
                                            @refreshAssignments="refreshAssignments" @setAlert="setAlert">
                                        </assignment-item>
                                    </div>
                                    <div v-else class="alert alert-primary">
                                        <i class="far fa-bells"></i> There are currently no completed queue items.
                                    </div>
                                </div>
                            </div>
                            <div v-else class="ado-assignment__load">
                                <i class="fas fa-spinner fa-spin fa-2x"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Auth from '../../js/auth';
import AssignmentItem from '../../components/Assignment/Assignment';

const DEPARTMENT = `Academic Dean's Office`;

export default {
    name: 'ado-admin-assignment',
    components: {
        AssignmentItem
    },
    data() {
        return {
            alert: {
                message: '',
                status: false,
                type: ''
            },
            alertTimer: '',
            assignmentRefresh: '',
            counsellor: '',
            counsellors: [],
            dataLoad: true,
            dataType: 'queue',
            dataResult: '',
            dequeueData: [],
            queueData: [],
            roleType: 'user'
        }
    },
    methods: {
        getAssignments() {
            this.dataType = 'queue';
        },
        getCompletedAssignments() {
            this.dataType = 'dequeue';
        },
        getCounsellorData() {
            // GET data
            this.getDequeue();
            this.getQueue();
        },
        getDequeue() {
            const that = this;
            let api = !this.counsellor ? `https://${location.hostname}/cgi-bin/mkvn-cardservices-backend/controller.cardservices.pl?getCounsellorAssignments&targetQueue=dequeued&department=${DEPARTMENT}` : `https://${location.hostname}/cgi-bin/mkvn-cardservices-backend/controller.cardservices.pl?getCounsellorAssignments&targetQueue=dequeued&department=${DEPARTMENT}&username=${this.counsellor}`;

            // GET request
            fetch(api)
                .then(function (response) {
                    // Return response
                    return response.json();
                })
                .then(function (json) {
                    if (json.result.match(/^OK/i)) {
                        // Queue items
                        that.dequeueData = json.data;

                        // Update counsellors if needed
                        if (that.counsellors.length == 0) {
                            that.counsellors = json.counsellors;
                        }

                        // Role type
                        if (!that.roleType) {
                            that.roleType = json.roleType;
                        }
                    }
                })
                .catch(function (error) {});
        },
        getQueue() {
            const that = this;
            let api = !this.counsellor ? `https://${location.hostname}/cgi-bin/mkvn-cardservices-backend/controller.cardservices.pl?getCounsellorAssignments&department=${DEPARTMENT}` : `https://${location.hostname}/cgi-bin/mkvn-cardservices-backend/controller.cardservices.pl?getCounsellorAssignments&department=${DEPARTMENT}&username=${this.counsellor}`;

            // GET request
            fetch(api)
                .then(function (response) {
                    // Return response
                    return response.json();
                })
                .then(function (json) {
                    if (json.result.match(/^OK/i)) {
                        // Queue items
                        that.queueData = json.data;

                        // Counsellors
                        that.counsellors = json.counsellors;

                        // Role type
                        that.roleType = json.roleType;
                    }

                    // Load icon
                    that.dataLoad = false;
                })
                .catch(function (error) {
                    // Load icon
                    that.dataLoad = false;
                })
        },
        refreshAssignments() {
            this.getQueue();
            this.getDequeue();
        },
        setAlert(message, type) {
            let that = this;

            // Set alert
            this.alert.message = message;
            this.alert.type = type;
            this.alert.status = true;

            // Set alert timer
            if (this.alert.status && !this.alertTimer) {
                setTimeout(function () {
                    that.alert.status = false;
                }, 3000);
            }
        }
    },
    computed: {
        getAlertClass() {
            if (this.alert.type == "success") {
                return `alert alert-success`;
            }

            if (this.alert.type == "warning") {
                return `alert alert-warning`;
            }

            if (this.alert.type == "success") {
                return `alert alert-danger`;
            }

            return `alert alert-primary`;
        },
        getAlertIcon() {
            if (this.alert.type == "success") {
                return `fas fa-check"`;
            }

            if (this.alert.type == "warning") {
                return `fas fa-exclamation-circle`;
            }

            if (this.alert.type == "success") {
                return `fas fa-exclamation-triangle`;
            }

            return `fas fa-bell`;
        },
        getAvatar() {
            let user = Auth.getUser();
            return user.avatar.path || `./../src/assets/avatar/avatar.jpg`;
        },
        getDepartment() {
            let user = Auth.getUser();
            return user.department || 'No department';
        },
        getDequeueCountClass() {
            return this.dequeueData.length > 0 ? 'ado-assignment__item-count--info' : '';
        },
        getDequeueType() {
            return 'dequeued';
        },
        getName() {
            let user = Auth.getUser();
            return user.commonName || 'No name';
        },
        getQueueCountClass() {
            return this.queueData.length > 0 ? 'ado-assignment__item-count--info' : '';
        },
        getQueueType() {
            return 'queued';
        },
        getTitle() {
            if (this.dataType == 'queue') return 'My Assignments';
            return 'Completed Assignments';
        },
        hasCounsellorsAccess() {
            return this.roleType == 'admin' ? true : false;
        }
    },
    created() {
        const that = this;

        // GET data
        this.refreshAssignments();

        // Auto refresh
        this.assignmentRefresh = setInterval(function () {
            that.refreshAssignments();
        }, 30000);
    },
    beforeDestroy() {
        // Clear refresh function
        clearInterval(this.assignmentRefresh);
    },
    destroyed() {
        // Clear refresh function
        clearInterval(this.assignmentRefresh);
    }
}
</script>

<style>
.assignment__item {
    margin-bottom: 1rem;
    padding-bottom: 1rem;
    border-bottom: 0.07rem dashed #ebedf2;
}

.assignment__item:last-child {
    border: none;
    margin: 0;
    padding: 0;
}

.ado-assignment__card {
    border: none;
    color: #595d6e;
    -webkit-box-shadow: 0px 0px 13px 0px rgba(82, 63, 105, 0.05);
    box-shadow: 0px 0px 13px 0px rgba(82, 63, 105, 0.05);
    background-color: #ffffff;
    margin-bottom: 20px;
    border-radius: 4px;
}

.ado-assignment__description {
    font-weight: 600;
    font-size: 14px;
    padding-top: 0.4rem;
    color: #74788d;
    -ms-flex: 1;
    -webkit-box-flex: 1;
    flex: 1;
}

.ado-assignment__header {
    font-size: 1.2rem;
    font-weight: 500;
    color: #434349;
    padding: 1rem;
    background-color: #fff;
    -webkit-box-shadow: 0px 10px 30px 0px rgba(82, 63, 105, 0.08);
    box-shadow: 0px 10px 30px 0px rgba(82, 63, 105, 0.08);
}

.ado-assignment__header-title {
    font-weight: 600;
    margin: 0;
}

.ado-assignment__item {
    margin-left: 46px;
}

.ado-assignment__item-count {
    color: #595d6e;
    font-weight: 500;
    font-size: 16px;
}

.ado-assignment__item-count--info {
    color: #fd397a;
    font-weight: 600;
}

.ado-assignment__item-title {
    color: #48465b;
    font-weight: 600;
    font-size: 12px;
}

.ado-assignment__load {
    color: #5d78ff;
    text-align: center;
}

.ado-assignment__profile {
    display: -ms-flexbox;
    display: -webkit-box;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
}

.ado-assignment__profile img {
    border-radius: 50%;
    margin-right: 1rem;
    height: 90px;
    width: 90px;
    -o-object-fit: cover;
    object-fit: cover;
}

.ado-assignment__stats {
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    width: 100%;
    border-top: 1px solid #ebedf2;
    margin-top: 2rem;
    padding-top: 1rem;
}

.ado-assignment__stats--item {}

.ado-assignment__stats--item i {
    float: left;
}

.ado-assignment__title {
    border-bottom: 1px solid #ebedf2;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    color: #48465b;
    font-size: 16px;
    font-weight: 700;
    min-height: 64px;
    padding: 16px 20px;
}

.ado-assignment__user {
    font-size: 18px;
    color: #48465b;
    font-weight: 600;
}

.icon__success {
    color: #0abb87;
}

.icon__warning {
    color: #ffb822;
}
</style>